var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30 7.5H6C4.34315 7.5 3 8.84315 3 10.5V25.5C3 27.1569 4.34315 28.5 6 28.5H30C31.6569 28.5 33 27.1569 33 25.5V10.5C33 8.84315 31.6569 7.5 30 7.5Z",
    fill: "url(#paint0_linear_8947_10775)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 12H3V16.5H33V12Z",
    fill: "url(#paint1_linear_8947_10775)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.5 21H25.5C24.6716 21 24 21.6716 24 22.5C24 23.3284 24.6716 24 25.5 24H28.5C29.3284 24 30 23.3284 30 22.5C30 21.6716 29.3284 21 28.5 21Z",
    fill: "url(#paint2_linear_8947_10775)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8947_10775",
    x1: 18,
    y1: 7.5,
    x2: 18,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8947_10775",
    x1: 18,
    y1: 12,
    x2: 18,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8947_10775",
    x1: 27,
    y1: 21,
    x2: 27,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A03B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.fa52223da12450725ab2cca49f807d29.svg";
export { ForwardRef as ReactComponent };